import { addMonths } from 'date-fns';

export const CONSENT_KEY = 'vl_consent';
let analyticsInitialized = false;

export function readConsent() {
  try {
    const value = JSON.parse(localStorage.getItem(CONSENT_KEY));
    if (value?.version === 2 && typeof value.analytics === 'boolean' && typeof value.marketing === 'boolean' && Date.parse(value.expiresAt) > Date.now()) return value;
  } catch {}
  return null;
}

export function writeConsent(analytics, marketing) {
  const date = new Date();
  const value = { version: 2, analytics: !!analytics, marketing: !!marketing, decidedAt: date.toISOString(), expiresAt: addMonths(date, 12).toISOString() };
  localStorage.setItem(CONSENT_KEY, JSON.stringify(value));
  applyAnalyticsConsent(value.analytics);
  window.dispatchEvent(new Event('vl-consent-updated'));
  return value;
}

export function applyAnalyticsConsent(allowed) {
  const sdk = window.posthog;
  if (!allowed) {
    if (analyticsInitialized) sdk?.opt_out_capturing?.();
    return;
  }
  const key = process.env.REACT_APP_POSTHOG_PROJECT_KEY;
  const host = process.env.REACT_APP_POSTHOG_API_HOST;
  if (!key || !host || !sdk) return;
  if (!analyticsInitialized) {
    sdk.init(key, { api_host: host, autocapture: false, capture_pageview: false, capture_pageleave: false, disable_session_recording: true, disable_surveys: true, opt_out_capturing_by_default: true,
      before_send: event => {
        if (!readConsent()?.analytics || /\/(betaling|account|beheer|afrekenen|order)/.test(window.location.pathname)) return null;
        const properties = { ...event.properties };
        Object.keys(properties).forEach(name => { if (/token|password|secret|email|phone|address|customer|order|referrer/i.test(name)) delete properties[name]; });
        properties.$current_url = window.location.origin + window.location.pathname;
        properties.$pathname = window.location.pathname;
        return { ...event, properties };
      },
    });
    analyticsInitialized = true;
  }
  sdk.opt_in_capturing();
}

export const openCookieSettings = () => window.dispatchEvent(new Event('vl-open-cookie-settings'));
